import React from 'react';

export default function Subpart({ options, selectedOptions, setSelectedOptions }) {
  // prepare array of selected labels for checkbox checked state
  const selected = selectedOptions.map(o => o.label);
  
  const toggleItem = (label) => {
    const item = options.find(o => o.label === label);
    if (!item) return;

    // Create the new item object
    const newItem = { value: item.label, label: item.label };
    
    setSelectedOptions(prev => {
      // Check if this item is already selected
      const isSelected = prev.some(v => v.label === label);
      
      if (isSelected) {
        // Remove the item from the array
        return prev.filter(v => v.label !== label);
      } else {
        // Add the item to the array (keep existing selections)
        return [...prev, newItem];
      }
    });
  };

  return (
    <div>
      <div className="w-full p-4 bg-white rounded shadow">
        <div className="w-full p-2 border-b-2 text-lg font-semibold text-blue-900 mb-2">
          Sub Part Type
        </div>

        <ul className="space-y-2 overflow-x-auto min-w-0 ps-0">
          {options.map((item) => (
            <li
              key={item.label} // ✅ unique
              className="flex items-start gap-2 ps-0"
            >
              <input
                id={`checkbox-${item.label}`} // ✅ unique
                type="checkbox"
                checked={selected.includes(item.label)}
                onChange={() => toggleItem(item.label)}
                className="h-5 w-5 mt-1 text-blue-600 flex-shrink-0"
              />
              <label
                htmlFor={`checkbox-${item.label}`}
                className="text-gray-800 text-[15px] cursor-pointer break-words leading-snug"
              >
                {item.label}
              </label>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
